

<div class="row">
  <div class="col-md-10 col-10">
    <h3 mat-dialog-title >{{ 'SorryServiceisnotavailable' | translate }}</h3>
  </div>
  <div class="col-md-2 p-0 col-2">
      <button mat-dialog-action class="btnLink closeModal text-right" (click)="close()"> <fa-icon [icon]="faTimesCircle"></fa-icon></button>
  </div>
</div>

<mat-dialog-content class="eligibility-text" >
<p>{{ 'WeareSorry,bookingserviceisnotavailableforyoucurrentlydueto' | translate }}:</p>
<ul>
  <li *ngFor="let item of customerElegibility"> {{item.message | translate}}</li>
</ul>

<p class="mt-3">{{ 'Pleasecontactagencytoknowmore' | translate }}:</p>
<ul>
  <li>{{vehicleReservationCaseDetailsModel.fromAgencyName}}</li>
  <li>{{vehicleReservationCaseDetailsModel.fromAgencyPhone}}</li>
  <li>{{vehicleReservationCaseDetailsModel.fromAgencyEmail}}</li>
</ul>

<button class="btn default-btn mt-4" mat-button (click)="backToHome()">{{ 'BackToHome' | translate }}</button>

</mat-dialog-content>






